import client from '@/base-http'
import { AnalysisReport } from '@/modules/seo/types'

/**
 * Genera el reporte de análisis SEO de una entidad metadata
 *
 * @param metadataId {number}
 */
export async function getAnalysisReport (metadata: number, locale: string) {
    const response = await client.get('/seo/analysis/report', {
        params: { metadata, locale },
    })

    return AnalysisReport.deserialize(response.data)
}
